module.exports = __webpack_public_path__ + "img/p6.82644c4d.png";